import React from 'react';
import { Dialog as MuiDialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './Dialog.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const CN = 'dialog';
const dialogTitleClassName = `${CN}__title`;
const dialogCloseIconClassName = `${CN}__close-icon`;

interface Props {
  title: string;
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  fullScreen?: boolean;
}

export const Dialog: React.FC<Props> = ({ title, open, handleClose, fullScreen = true, children }) => (
  <MuiDialog onClose={ handleClose } open={ open } fullScreen={ fullScreen }>
    <DialogTitle className={ cx(dialogTitleClassName) }>
      {title}
      <IconButton
        onClick={ handleClose }
        className= { cx(dialogCloseIconClassName) }
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {children}
    </DialogContent>
  </MuiDialog>
);
